import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configConstants } from "main/src/js/constants";
import { setCurrentDashboardView } from "main/src/modules/dashboard/actionCreators";
import { DASHBOARD_VIEWS } from "main/src/modules/dashboard/constants";
import { usePersonalizedHomepage } from "@certa/common/hooks/usePersonalizedHomepage";
import type { InstanceConfiguration } from "@certa/queries/types/config.types";

/**
 * Hook for maintaining Redux compatibility with config data
 *
 * This hook dispatches config state changes to Redux for backward compatibility
 * with components that still rely on Redux selectors for config data.
 *
 * @deprecated This hook should be removed after full migration to React Query
 */
export const useConfigReduxCompatibility = (
  isConfigLoading: boolean,
  configError: any,
  isNewAuthFlowEnabled: boolean,
  config?: InstanceConfiguration
) => {
  const dispatch = useDispatch();
  const { isPersonalisedHomepageVisible } = usePersonalizedHomepage();

  // Handle config loading and Redux storage (matches config.js logic)
  useEffect(() => {
    if (!isNewAuthFlowEnabled) {
      return;
    }
    if (isConfigLoading) {
      dispatch({ type: configConstants.CONFIG_REQUEST });
    } else if (configError) {
      if (configError?.status === 503) {
        configError.res?.json?.().then((res: any) =>
          dispatch({
            type: configConstants.CONFIG_MAINTANANCE_FAILURE,
            maintananceErrorData: {
              showMaintanancePage: true,
              maintananceData: res
            }
          })
        );
      } else {
        dispatch({
          type: configConstants.CONFIG_FAILURE,
          error: configError
        });
      }
    } else if (config) {
      dispatch({
        type: configConstants.CONFIG_SUCCESS,
        config
      });

      dispatch(
        setCurrentDashboardView(
          isPersonalisedHomepageVisible
            ? DASHBOARD_VIEWS.MY_STUFF
            : DASHBOARD_VIEWS.KIND_VIEW
        )
      );
    }
  }, [
    config,
    isConfigLoading,
    configError,
    dispatch,
    isPersonalisedHomepageVisible,
    isNewAuthFlowEnabled
  ]);
};
